import db from "../Db";

export function IsOracle() {
  return new Promise(function (resolve, reject) {
    if (!db.isOpen()) {
      db.open();
    }

    db.CLIENT.get(1).then((result) => {
      return resolve(result.ORACLE);
    });
  });
}
